<script>
  import { createEventDispatcher } from 'svelte';
  import { Icon, DialogNew, Checkbox } from '@shopboxai/sb-portal-components';
  let type = 0;
  let collections = ['new_for_you', 'promotions_for_you', 'recommendations', 'recently_viewed', 'previously_purchased', 'custom_products'];
  let fallbackCollections = [
    'top_viewed',
    'trending_view_products',
    'top_viewed_new_products',
    'top_viewed_offer_products',
    'top_order_products',
    'custom_products',
  ];

  export let data = { type: 'banner', size: 1, title: '', collection: 'banner', includeOnMobile: false, includeOnDesktop: true };
  const dispatch = createEventDispatcher();
  const submitDialog = () => {
    dispatch('submit', data);
    type = 0;
    data = { type: 'banner', size: 1, title: '', collection: 'banner', includeOnMobile: false, includeOnDesktop: true };
  };
  const resetData = () => {
    type = 0;
    data = { type: 'banner', size: 1, title: '', collection: 'banner', includeOnMobile: false, includeOnDesktop: true };
  };
</script>

<DialogNew on:submit={submitDialog} on:close={resetData}>
  <div slot="toggle">
    <button class="primary">Add new item</button>
  </div>
  <div slot="header">Add grid item</div>

  <button class="primary" slot="primary-action">Create</button>
  <div slot="content" class="dialog-form-wrapper">
    <div class="dialog-form-type">
      <button
        on:click={() => {
          type = 0;
          data.type = 'banner';
        }}
        class="dialog-type-box"
        class:active={type == 0}
      >
        <Icon name="image" />
        <p>Banner</p>
      </button>
      <button
        on:click={() => {
          type = 1;
          data.type = 'collection';
        }}
        class="dialog-type-box"
        class:active={type == 1}
      >
        <Icon name="collection" />
        <p>Product collection</p>
      </button>
    </div>

    <label for="title">Title</label>
    <input id="title" type="text" bind:value={data.title} />
    {#if type == 0}
      <div class="dialog-form-banner ">
        <label for="action">Action URL</label>
        <input id="action" type="text" bind:value={data.url} />
        <label for="image">Image URL</label>
        <input id="image" type="text" bind:value={data.image_url} />
        <p class="tip">Recommended image size is below 1MB.</p>
      </div>
    {:else}
      <div class="dialog-form-product-collection ">
        <label for="collection">Dynamic Product collection</label>
        <select bind:value={data.collection}>
          <option disabled>Dynamic Collections</option>
          {#each collections as collection}
            <option value={collection}>{collection}</option>
          {/each}
          <option disabled>Static Collections</option>
          {#each fallbackCollections as collection}
            <option value={collection}>{collection}</option>
          {/each}
        </select>
        <label for="fallback-title">Static Product Title</label>
        <input id="fallback-title" type="text" bind:value={data.fallback_title} />
        <label for="collection">Static Product Collection</label>
        <select bind:value={data.fallback}>
          {#each fallbackCollections as collection}
            <option value={collection}>{collection}</option>
          {/each}
        </select>
        <p class="radio-heading">Number of products</p>
        <div class="radio-wrapper">
          <input type="radio" name="select" bind:group={data.num_products} id="num-1" value={1} checked />
          <label for="num-1" class="radio-label">1</label>
          <input type="radio" name="select" bind:group={data.num_products} id="num-3" value={3} />
          <label for="num-3" class="radio-label">3</label>
          <input type="radio" name="select" id="num-4" bind:group={data.num_products} value={4} />
          <label for="num-4" class="radio-label">4</label>
          <input type="radio" name="select" id="num-12" bind:group={data.num_products} value={12} />
          <label for="num-12" class="radio-label">12 (Carousel)</label>
        </div>
      </div>
    {/if}
    <div class="device-selectors">
      <Checkbox bind:value={data.includeOnDesktop} labelText="Include on desktop" />
      <Checkbox bind:value={data.includeOnMobile} labelText="Include on mobile" />
    </div>
  </div>
</DialogNew>

<style>.dialog-form-wrapper{min-height:360px}.dialog-form-type{grid-gap:1em;display:grid;grid-template-columns:1fr 1fr;margin-bottom:1em}.dialog-type-box{border:1px solid #727178;border-radius:3px;box-sizing:border-box;cursor:pointer;display:grid;padding:14px 12px;place-content:center;text-align:center}.dialog-type-box.active{background:#f0f8ff;border-color:#091eb5;color:#091eb5}.dialog-type-box.active :global(svg>*){stroke:#091eb5}.radio-wrapper{display:grid;grid-auto-flow:column}.radio-label{border:1px solid #727178;cursor:pointer;padding:8px;text-align:center}.tip{color:#727178;font-size:12px;margin-top:0}input[type=radio]{display:none}input[type=radio]:checked+label{background:#f0f8ff;border-color:#0069d9;color:#091eb5}</style>
